import { render, staticRenderFns } from "./EmptyComponent.vue?vue&type=template&id=18cb61ca"
import script from "./EmptyComponent.vue?vue&type=script&lang=js"
export * from "./EmptyComponent.vue?vue&type=script&lang=js"
import style0 from "./EmptyComponent.vue?vue&type=style&index=0&id=18cb61ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports